module.exports = __webpack_public_path__ + "static/media/junior_tour_step3.483fe75e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gJunior/junior_tour_step3.svg
// module id = 329
// module chunks = 21